// Copyright Epic Games, Inc. All Rights Reserved.

export default {
  messages: {
    "error.errorCode": "Код ошибки:",
    "error.search": "Выполните поиск по нашей базе знаний, чтобы узнать больше",
    dismiss: "отменить",
    "installation.title": "",
    "cancelation.button": "Отмена",
  },
  errorCodes: {
    "EOS-UI-NF": {
      title: "Ошибка инициализации",
      description:
        "Не удалось отобразить страницу. Свяжитесь со службой поддержки.",
    },
    "EOS-UI-UE": {
      title: "Что-то пошло не так.",
      description: "Что-то пошло не так. Свяжитесь со службой поддержки.",
    },
    "EOS-IN-BC": {
      title: "Сбой установки",
      description:
        "Мы не смогли показать прогресс установки. Свяжитесь со службой поддержки.",
    },
    "EOS-IN-UE": {
      title: "Сбой установки",
      description: "Что-то пошло не так. Свяжитесь со службой поддержки.",
    },
    "EOS-IN-FF": {
      title: "Сбой установки",
      description:
        "Нам не удалось подключиться к Epic Online Services. Свяжитесь со службой поддержки.",
    },
    "EOS-IN-FF-*": {
      title: "Сбой установки",
      description:
        "Нам не удалось отправить запрос в Epic Online Services. Свяжитесь со службой поддержки.",
    },
    fallback: {
      title: "Что-то пошло не так.",
      description: "Что-то пошло не так. Свяжитесь со службой поддержки.",
    },
  },
};
